(function()
{
	"use strict";

	function LoaderTransition()
	{
		this.ViewTransition_constructor();
		this.visible = true;
		this.progress = 0;
	}

	var p = createjs.extend(LoaderTransition, cm.ViewTransition);

	p.build = function()
	{
		//-173
		this.width = cm.app.display.width/2;
		this.height = cm.app.display.height/2;
		this.topBg = new cjs.Bitmap(cm.Assets.lib.toploaderbg).set({x:0, y: 0}).center();
		this.bottomBG = new cjs.Bitmap(cm.Assets.lib.bottomloaderbg).set({x:0, y: 0}).center();
		this.topBg.on("mouseover", function(){});
		this.bottomBG.on("mouseover", function(){});
		var frontFrame = new cjs.Bitmap(cm.Assets.lib.loaderfrontframe).set({x:4, y:144}).center();
		this.loadBar = new cjs.Bitmap(cm.Assets.lib.loadingbar).set({x:-172, y:145, regX: 351, regY: 35.5});
		this.topContainer = new cjs.Container();
		this.topContainer.y = -125;
		this.bottomContainer = new cjs.Container();
		this.topContainer.addChild(this.topBg, this.loadBar, frontFrame);
		this.bottomContainer.addChild(this.bottomBG);
		this.bottomContainer.y = 172;
		this.addChild(this.bottomContainer, this.topContainer);
		this.createRect();
	};

	p.createRect = function()
	{
		var graphic = new cjs.Graphics();
		graphic.f("#fff").dr(0,0, 355, 100);
		var shape = new cjs.Shape(graphic);
		shape.alpha = 0.5;
		shape.x = -173;
		shape.y = 111;
		this.loadBar.mask = shape;

		// this.topContainer.addChild(shape);

	};

	p.callLoader = function()
	{
		this.visible = true;
		if(!app.voPlayer.playing)
			app.voPlayer.play([500, "vo-167"]);

			cm.app.sound.play("loading-in");

		cjs.Tween.get(this.topContainer).set({visible:true}).to({y:-125}, 1000, cjs.Ease.quadOut);
		cjs.Tween.get(this.bottomContainer).set({visible:true}).to({y:172}, 1000, cjs.Ease.quadOut);
		this.loadBar.visible = true;
		return 1200;
	};

	p.transitIn = function()
	{
		if(!app.voPlayer.playing)
			app.voPlayer.play([500, "vo-167"]);

			cm.app.sound.play("loading-in");


		this.visible = true;
		cjs.Tween.get(this.topContainer).set({visible:true}).to({y:-125}, 1000, cjs.Ease.quadOut);
		cjs.Tween.get(this.bottomContainer).set({visible:true}).to({y:172}, 1000, cjs.Ease.quadOut);
		cjs.Tween.get(this.loadBar).wait(1000).set({visible:true}).to({x:177}, 500);
		return 1500;
	};

	p.transitOut = function()
	{
		cm.app.sound.play("loading-out");
		cjs.Tween.get(this.topContainer).to({y:-650}, 1000, cjs.Ease.quadIn).set({visible:false});
		cjs.Tween.get(this.bottomContainer).to({y:610}, 1000, cjs.Ease.quadIn).set({visible:false});
		cjs.Tween.get(this.loadBar).wait(1000).set({x:-176}).set({visible:false});
		return 1000;
	};

	p.progressBar = function(e)
	{
		this.loadBar.x = -172 + 349 * e.progress;
		// console.log(this.loadBar.x);
	};

	p._tick = function(e)
	{
		this.ViewTransition__tick(e);
	};

	cm.LoaderTransition = cjs.promote(LoaderTransition, "ViewTransition");
})();